import { useEffect, useState } from "react";
import SectionHeader from "@/components/SectionHeader";
import FAQAccordion from "@/components/FAQAccordion";
import RiskDisclosure from "@/components/RiskDisclosure";
import FinalCTA from "@/components/FinalCTA";
import { Reveal, MaskReveal } from "@/components/Reveal";
import { FAQS, FAQ_CATEGORIES } from "@/data/content";

const Faq = () => {
  const [cat, setCat] = useState("All");

  useEffect(() => {
    document.title = "FAQ — Courses, EnTrade & Risk Questions | T Plus One";
  }, []);

  const items = cat === "All" ? FAQS : FAQS.filter((f) => f.category === cat);

  return (
    <main className="pt-32 lg:pt-40" data-testid="faq-page">
      <div className="container-x pb-24 lg:pb-32">
        <header className="max-w-3xl">
          <Reveal><p className="eyebrow">FAQ</p></Reveal>
          <MaskReveal as="h1" lines={["Questions, answered plainly."]} className="mt-6 text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.08]" />
          <Reveal delay={0.2}>
            <p className="mt-8 text-base sm:text-lg text-dim leading-relaxed">Everything about our courses, EnTrade membership, learning formats and how we talk about risk.</p>
          </Reveal>
        </header>

        <Reveal delay={0.25}>
          <div className="mt-12 flex flex-wrap gap-2" role="tablist" aria-label="FAQ categories">
            {["All", ...FAQ_CATEGORIES].map((c) => (
              <button
                key={c}
                role="tab"
                aria-selected={cat === c}
                data-testid={`faq-tab-${c.toLowerCase()}`}
                onClick={() => setCat(c)}
                className={`rounded-full px-5 py-2.5 text-sm border transition-colors ${
                  cat === c ? "bg-ink text-ivory border-ink" : "border-line text-dim hover:border-ink/30"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </Reveal>

        <div className="mt-10 grid lg:grid-cols-[1fr_360px] gap-14 items-start">
          <FAQAccordion items={items} />
          <aside className="lg:sticky lg:top-28">
            <RiskDisclosure />
          </aside>
        </div>
      </div>
      <FinalCTA />
    </main>
  );
};

export default Faq;
